import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  PATCH_USER_SUCCESS,
  PATCH_USER_ERROR,
  CLEAR_PATCH_USER,
  ADD_CUSTOM_DOMAIN_SUCCESS,
  ADD_CUSTOM_DOMAIN_ERROR,
  CLEAR_CUSTOM_DOMAIN,
  FETCH_CUSTOM_DOMAIN_INFO,
  FETCH_CUSTOM_DOMAIN_INFO_ERROR,
  CLEAR_CUSTOM_DOMAIN_INFO,
  DELETE_CUSTOM_DOMAIN_SUCCESS,
  DELETE_CUSTOM_DOMAIN_ERROR,
  CLEAR_DELETE_CUSTOM_DOMAIN,
} from 'redux/settings/types';


export const patchUser = formData => baseErrorsHandlerDecorator(
  PATCH_USER_SUCCESS,
  PATCH_USER_ERROR,
  () => restapi.patch(addLang(`users/me/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchUser = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_USER,
  });
};

// CUSTOM DOMAIN
export const addCustomDomain = domain => baseErrorsHandlerDecorator(
  ADD_CUSTOM_DOMAIN_SUCCESS,
  ADD_CUSTOM_DOMAIN_ERROR,
  () => restapi.post(addLang('users/custom_domain/'), { domain }),
);

export const clearCustomDomainStatus = () => dispatch => {
  dispatch({
    type: CLEAR_CUSTOM_DOMAIN,
  });
};

export const fetchCustomDomainInfo = id => baseErrorsHandlerDecorator(
  FETCH_CUSTOM_DOMAIN_INFO,
  FETCH_CUSTOM_DOMAIN_INFO_ERROR,
  () => restapi.get(addLang(`users/custom_domain/${id}/`))
);

export const clearCustomDomainInfo = () => dispatch => {
  dispatch({
    type: CLEAR_CUSTOM_DOMAIN_INFO,
  });
};

export const deteleCustomDomain = id => baseErrorsHandlerDecorator(
  DELETE_CUSTOM_DOMAIN_SUCCESS,
  DELETE_CUSTOM_DOMAIN_ERROR,
  () => restapi.delete(addLang(`users/custom_domain/${id}/`))
);

export const clearCustomDomainDeleteStatus = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_CUSTOM_DOMAIN,
  });
};
// end CUSTOM DOMAIN
